import { IconProps } from "../../types/utils";

const BigAddIcon = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 44}
    height={dimension || 44}
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.25 37.75C16.25 40.9136 18.8364 43.5 22 43.5C25.1636 43.5 27.75 40.9136 27.75 37.75V27.75H37.75C40.9136 27.75 43.5 25.1636 43.5 22C43.5 18.8364 40.9136 16.25 37.75 16.25H27.75V6.25C27.75 3.08636 25.1636 0.5 22 0.5C18.8364 0.5 16.25 3.08636 16.25 6.25V16.25H6.25C3.08636 16.25 0.5 18.8364 0.5 22C0.5 25.1636 3.08636 27.75 6.25 27.75H16.25V37.75Z"
      fill={color || "#CBD1D9"}
      stroke="white"
    />
  </svg>
);

export default BigAddIcon;
